import React, { useState, useEffect} from "react";
import { Link } from "react-router-dom";
import "./Home.css";

import img1 from "./homeimages/img2.jpg";
import img2 from "./homeimages/img1.jpg";
import img3 from "./homeimages/img3.jpg";
import img5 from "./homeimages/img5.avif";
import img6 from "./homeimages/img6.jpeg";

const images = [img1, img2, img3, img5, img6];

const teamMembers = [
  { name: "Md Aftab Alam",  role: "Founder & CEO",      img: "https://res.cloudinary.com/dwj0k0vf9/image/upload/f_auto,q_auto/Screenshot_2026-04-06_225554_ic29rj" },
  { name: "Sajjid Aftab",   role: "Operations Manager",  img: "https://res.cloudinary.com/dmqb6h3ys/image/upload/f_auto,q_auto/Screenshot_2026-04-03_203443_x5vusj" },

];

const clients = [
  { name: "Rajesh Kumar",  role: "Wholesale Buyer",  location: "Mumbai",    img: "https://randomuser.me/api/portraits/men/45.jpg" },
  { name: "Anita Sharma",  role: "Retail Partner",   location: "Delhi",     img: "https://randomuser.me/api/portraits/women/48.jpg" },
  { name: "Mohammed Ali",  role: "Importer",         location: "Dubai",     img: "https://randomuser.me/api/portraits/men/52.jpg" },
  { name: "Suresh Patel",  role: "Distributor",      location: "Ahmedabad", img: "https://randomuser.me/api/portraits/men/61.jpg" },
  { name: "Neha Verma",    role: "Store Owner",      location: "Lucknow",   img: "https://randomuser.me/api/portraits/women/65.jpg" },
  { name: "John Martin",   role: "Importer",         location: "UK",        img: "https://randomuser.me/api/portraits/men/68.jpg" },
];

const packaging = [
  { icon: "🌱", title: "Farm Harvesting",    desc: "Fruits collected from farms at the right stage for best quality and shelf life." },
  { icon: "🧼", title: "Cleaning & Sorting", desc: "Manually cleaned and sorted to remove damaged or low-quality items." },
  { icon: "🔍", title: "Quality Check",      desc: "Basic quality checks done to match buyer requirements before dispatch." },
  { icon: "📦", title: "Packaging",          desc: "Packed in suitable boxes depending on quantity and transport distance." },
  { icon: "❄️", title: "Cold Storage",       desc: "Temperature-controlled storage used for selected orders to maintain freshness." },
  { icon: "🚚", title: "Delivery",           desc: "Dispatched via trusted transport partners for safe, timely delivery." },
];

const stats = [
  { num: "500+",  label: "Regular Buyers" },
  { num: "1200+", label: "Orders Processed" },
  { num: "50+",   label: "Supplier Partners" },
  { num: "10+",   label: "Markets Served" },
];

const Home = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [heroVisible, setHeroVisible] = useState(false);

  useEffect(() => {
    setHeroVisible(true);
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home-page">

      {/* ── HERO ── */}
      <section className="h-hero">
        {images.map((img, i) => (
          <div
            key={i}
            className={`h-hero__slide ${i === currentImage ? "active" : ""}`}
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
        <div className="h-hero__overlay" />
        <div className={`h-hero__content ${heroVisible ? "visible" : ""}`}>
          <span className="h-hero__badge">🌿 Farm to Doorstep</span>
          <h1 className="h-hero__title">
            Fresh Fruits,<br />
            <em>Straight from</em><br />
            the Source
          </h1>
          <p className="h-hero__sub">
            We supply fresh fruits sourced directly from farmers and local exporters —
            proper handling, honest quality, and timely delivery for bulk buyers worldwide.
          </p>
          <div className="h-hero__actions">
            <Link to="/products" className="h-btn h-btn--primary">View Products</Link>
            <Link to="/contact"  className="h-btn h-btn--ghost">Contact Us</Link>
          </div>
        </div>
        <div className="h-hero__dots">
          {images.map((_, i) => (
            <button
              key={i}
              className={`h-hero__dot ${i === currentImage ? "active" : ""}`}
              onClick={() => setCurrentImage(i)}
            />
          ))}
        </div>
      </section>

      {/* ── ABOUT ── */}
      <section className="h-about">
        <div className="h-about__inner">
          <div className="h-about__text">
            <span className="h-label">Who We Are</span>
            <h2 className="h-heading">Connecting Farms<br />to Buyers, Directly</h2>
            <p>
              We are involved in sourcing, packing, and supplying fruits in bulk.
              By coordinating with farmers and exporters, we help move fresh produce
              from farms to buyers — with consistent quality, clear communication,
              and dependable service.
            </p>
            <Link to="/about" className="h-btn h-btn--outline">Learn More</Link>
          </div>
          <div className="h-about__image">
            <img
              src="https://images.unsplash.com/photo-1610832958506-aa56368176cf?w=700&q=80"
              alt="Fresh fruits"
            />
            <div className="h-about__badge-float">
              <span className="num">8+</span>
              <span className="lbl">Years of Trust</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── MISSION & VISION ── */}
      <section className="h-mv">
        <span className="h-label" style={{textAlign:"center",display:"block"}}>Our Purpose</span>
        <h2 className="h-heading" style={{textAlign:"center",marginBottom:"48px"}}>What Drives Us</h2>
        <div className="h-mv__grid">
          <div className="h-mv__card">
            <img src="https://images.unsplash.com/photo-1464965911861-746a04b4bca6?w=600&q=75" alt="Mission" className="h-mv__img" />
            <div className="h-mv__body">
              <div className="h-mv__icon">🎯</div>
              <h3>Our Mission</h3>
              <p>Supply fresh fruits in bulk with proper handling and fair pricing, while supporting farmers and building long-term buyer relationships.</p>
            </div>
          </div>
          <div className="h-mv__card h-mv__card--gold">
            <img src="https://images.unsplash.com/photo-1550258987-190a2d41a8ba?w=600&q=75" alt="Vision" className="h-mv__img" />
            <div className="h-mv__body">
              <div className="h-mv__icon">✨</div>
              <h3>Our Vision</h3>
              <p>Grow steadily as a reliable fruit supply partner for domestic and international markets, focusing on honesty and consistency.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── WHY CHOOSE US ── */}
      <section className="h-why">
        <div className="h-why__inner">
          <span className="h-label h-label--light">Why Us</span>
          <h2 className="h-heading h-heading--light">Reliability Over<br />Everything Else</h2>
          <div className="h-why__grid">
            {[
              { icon: "🌱", title: "Direct Sourcing",     desc: "Fruits sourced straight from farmers and local suppliers, cutting unnecessary middlemen." },
              { icon: "📦", title: "Smart Packaging",     desc: "Practical, protective packaging that minimizes wastage during transport." },
              { icon: "🚚", title: "On-Time Delivery",    desc: "Trusted transport partners ensuring your order reaches safely and on schedule." },
              { icon: "💬", title: "Clear Communication", desc: "You always know the status of your order — no guesswork, no surprises." },
            ].map((item, i) => (
              <div className="h-why__card" key={i}>
                <span className="h-why__icon">{item.icon}</span>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── STATS ── */}
      <section className="h-stats">
        {stats.map((s, i) => (
          <div className="h-stats__item" key={i}>
            <span className="h-stats__num">{s.num}</span>
            <span className="h-stats__lbl">{s.label}</span>
          </div>
        ))}
      </section>

      {/* ── TEAM ── */}
      <section className="h-team">
        <span className="h-label" style={{textAlign:"center",display:"block"}}>The People Behind</span>
        <h2 className="h-heading" style={{textAlign:"center",marginBottom:"48px"}}>Meet Our Team</h2>
        <div className="h-team__grid">
          {teamMembers.map((m, i) => (
            <div className="h-team__card" key={i}>
              <div className="h-team__photo">
                <img src={m.img} alt={m.name} />
              </div>
              <div className="h-team__info">
                <div className="h-team__name">{m.name}</div>
                <div className="h-team__role">{m.role}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── CLIENTS SCROLL ── */}
      <section className="h-scroll-section">
        <span className="h-label" style={{textAlign:"center",display:"block"}}>Who We Work With</span>
        <h2 className="h-heading" style={{textAlign:"center",marginBottom:"12px"}}>Our Clients</h2>
        <p className="h-scroll-section__desc">
          Wholesalers, retailers, distributors, and importers who value consistency and clear communication.
        </p>
        <div className="h-scroll-wrap">
          <div className="h-scroll-track">
            {[...clients, ...clients].map((c, i) => (
              <div className="h-scroll-card" key={i}>
                <img src={c.img} alt={c.name} />
                <strong>{c.name}</strong>
                <small>{c.role} · {c.location}</small>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── PROCESS SCROLL ── */}
      <section className="h-scroll-section h-scroll-section--light">
        <span className="h-label" style={{textAlign:"center",display:"block"}}>Step by Step</span>
        <h2 className="h-heading" style={{textAlign:"center",marginBottom:"12px"}}>How We Handle Orders</h2>
        <p className="h-scroll-section__desc">
          From farm collection to your doorstep — every step handled with care.
        </p>
        <div className="h-scroll-wrap">
          <div className="h-scroll-track h-scroll-track--slow">
            {[...packaging, ...packaging].map((p, i) => (
              <div className="h-scroll-card h-scroll-card--process" key={i}>
                <span className="h-scroll-card__icon">{p.icon}</span>
                <strong>{p.title}</strong>
                <p>{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="h-cta">
        <div className="h-cta__inner">
          <span className="h-label h-label--light">Ready to Order?</span>
          <h2 className="h-heading h-heading--light">Bulk Fruit Supply<br /><em>Made Simple</em></h2>
          <p>
            Looking for a dependable fruit supplier for bulk orders?
            Explore our products or reach out for a discussion.
          </p>
          <div className="h-cta__actions">
            <Link to="/products" className="h-btn h-btn--primary">View All Products</Link>
            <Link to="/contact"  className="h-btn h-btn--ghost">Get in Touch</Link>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;